/**
 * @file 格式化qb页提问 回答相关信息
 */

const DEFAULT_AVATAR = 'https://gss0.bdstatic.com/7051cy89RcgCncy6lo7D0j9wexYrbOWh7c50/yt/bdsp/icon/default.png';
const ANONYMOUSURL = 'https://gss0.bdstatic.com/7051cy89Q1gCncy6lo7D0j9wexYrbOWh7c50/yt/bdsp/icon/anonymous.png';
const NETFRIENDURL = 'https://gss0.bdstatic.com/7051cy89RcgCncy6lo7D0j9wexYrbOWh7c50/yt/bdsp/icon/net-friend.png';

/**
 * 格式化点赞数据
 */

export let formatThumb = function (num) {
  if (+num === 0) {
    return 0;
    // } else if (+num > 100000) {
    //     // 超出10w展示10w+
    //     return '10w+'
    // }
    // else if (+num === 100000) {
    //     // 100000展示10w
    //     return '10w'
  } else if (+num >= 10000) {
    // 整万展示w位,w位后展示小数点1位，过百进一
    // 例:10001～10099展示数字1w,11000～11999展示数字1.1w
    return Math.floor(+num / 1000) / 10 + '万';
  }
  return +num;
};
export let foldTextOnly = function (text, num) {
  text = text.replace(/\n/g, '');
  if (text.length > num) {
    text = text.substr(0, num) + '...';
  }
  return {
    text,
    hasMoreReplyInfo: text.length > num
  };
};

/**
 * 设置描述文字截断
 */

export let foldText = function (item, num) {
  let text = item.contentText && item.contentText.replace(/\n/g, '') || '';
  if (text.length > num) {
    item.replyInfo = text.substr(0, num) + '...';
    item.hasMoreReplyInfo = 1;
  } else {
    item.replyInfo = text;
    item.hasMoreReplyInfo = 0;
  }
  return item;
};

/**
 * 设置用户头像等信息
 */

export let setAuthorInfo = function (reply, from) {
  let answerUser = reply.user;
  if (answerUser.showInfo) {
    answerUser.canJump = answerUser.showInfo.siteUrl && answerUser.showInfo.siteUrl !== 'javascript:void(0)';
    // 为了兼容，我一定会删掉的
    answerUser.iconChange = 1;
    answerUser.displayName = answerUser.showInfo.name;
    answerUser.displayInfo = answerUser.showInfo.slogan;
    answerUser.displayImg = answerUser.showInfo.imgUrl;
    answerUser.userHomeLink = answerUser.showInfo.siteUrl;
    if (+answerUser.showInfo.type === 2) {
      answerUser.displayType = 'business';
    } else if (+answerUser.showInfo.type === 3) {
      answerUser.displayType = 'expert';
    } else if (+answerUser.showInfo.type === 6) {
      answerUser.displayType = 'mavin';
    } else if ([0, 4, 5].includes(+answerUser.showInfo.type)) {
      answerUser.displayType = 'ugc';
    }
  } else {
    let displayImg = reply.user.iconChange ? 'http://himg.bdimg.com/sys/portrait/item/' + reply.user.imId + '.jpg' : DEFAULT_AVATAR;
    answerUser.userHomeLink = '/pages/ucenter/ucenter?uid=' + answerUser.uid;
    if (reply.user.isAnonymous) {
      // 匿名
      answerUser.iconChange = 1;
      answerUser.displayName = '匿名用户';
      answerUser.displayInfo = '';
      answerUser.displayImg = ANONYMOUSURL;
      answerUser.canJump = 0; // 标志用户不能跳转个人页
    } else if (reply.government_partner) {
      // {%* 政府 *%}
      answerUser.iconChange = 1;
      answerUser.displayType = 'government';
      answerUser.displayImg = reply.user.business.imgUrl;
      answerUser.displayName = reply.user.business.name || '';
      answerUser.displayInfo = reply.user.business.slogan || '';
      answerUser.canJump = 1; // 标志用户能跳转个人页
      answerUser.userHomeLink += '&role=business&businessId=' + answerUser.business.businessId;
    } else if (reply.user.business) {
      // {%* 企业 *%}
      answerUser.iconChange = 1;
      answerUser.displayType = 'business';
      answerUser.displayImg = reply.user.business.imgUrl;
      answerUser.displayName = reply.user.business.name || '';
      answerUser.displayInfo = reply.user.business.slogan || '';
      answerUser.canJump = 1; // 标志用户能跳转个人页
      answerUser.userHomeLink += '&role=business&businessId=' + answerUser.business.businessId;
    } else if (reply.user.newAuthUser) {
      // {%* 新认证行家 *%}
      answerUser.iconChange = 1;
      answerUser.displayType = 'expert';
      answerUser.displayImg = reply.user.newAuthUser.avatar;
      answerUser.displayName = reply.user.newAuthUser.name || '';
      answerUser.displayInfo = reply.user.newAuthUser.slogan || '';
      answerUser.siteUrl = reply.user.newAuthUser.siteUrl || '';
      answerUser.canJump = 1; // 标志用户能跳转个人页
      answerUser.userHomeLink += '&role=pgc';
    } else if (reply.user.mavin && !reply.user.isNoUserName) {
      // {%* 行家 *%}
      answerUser.displayName = reply.user.mavin.showName || reply.user.name;
      answerUser.displayImg = reply.user.mavin.showImg || displayImg;
      answerUser.displayType = 'mavin';
      answerUser.displayInfo = reply.user.mavin.title || '';
      answerUser.canJump = 1; // 标志用户能跳转个人页
      answerUser.userHomeLink += '&role=mavin';
    } else {
      if (reply.user.isUnLogin || reply.user.isNoUserName || reply.user.name.indexOf('cn#') > -1) {
        answerUser.displayName = '热心网友';
        answerUser.displayInfo = '';
        answerUser.displayImg = NETFRIENDURL;
        answerUser.canJump = 0; // 标志用户不能跳转个人页
      } else {
        answerUser.displayName = reply.user.name;
        answerUser.displayInfo = ['question', 'squestion'].includes(from) ? '' : 'LV.' + reply.user.gradeIndex;
        answerUser.displayImg = displayImg;
        answerUser.canJump = 1; // 标志用户能跳转个人页
        answerUser.userHomeLink += '&role=ugc';
      }
      answerUser.displayType = 'ugc';
    }
  }
  return reply;
};
export let setNumThousands = function (num) {
  let numb = (num || 0).toString();
  let result = '';
  while (numb.length > 3) {
    result = ',' + numb.slice(-3) + result;
    numb = numb.slice(0, numb.length - 3);
  }
  if (numb) {
    result = numb + result;
  }
  return result;
};